/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Shot_DocumentInputs */

const en_tut_shot_document = /** @type {(inputs: Tut_Shot_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A document in preview mode: a proposal with a summary, a per-week target table, and a list of open decisions; Manage access and Enable co-editing buttons above it.`)
};

const id_tut_shot_document = /** @type {(inputs: Tut_Shot_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman Dokumen dalam mode pratinjau: proposal dengan ringkasan, tabel target per pekan, dan daftar hal yang perlu diputuskan; tombol Kelola akses dan Aktifkan penyuntingan bersama di atasnya.`)
};

/**
* | output |
* | --- |
* | "A document in preview mode: a proposal with a summary, a per-week target table, and a list of open decisions; Manage access and Enable co-editing buttons abo..." |
*
* @param {Tut_Shot_DocumentInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_shot_document = /** @type {((inputs?: Tut_Shot_DocumentInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Shot_DocumentInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_shot_document(inputs)
	return en_tut_shot_document(inputs)
});